import { Score } from './score';

export class PlayerScores {
    name: string;
    order: number;
    scores: Score[];
    message?: string;

    get sumOut(): number {
        return this.scores.slice(0, 9).reduce((a, b) => a + b.score, 0);
    }

    get sumIn(): number {
        return this.scores.slice(9, 18).reduce((a, b) => a + b.score, 0);
    }
}
